import MenuItemAccount from 'components/shared/Header/menuItems/MenuItemAccount.jsx'
import LogoutButton from 'components/shared/Logout/LogoutButton'
import Navigation from 'components/shared/Navigation/Navigation'
import logo from 'images/logo.svg'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar, toggleSidebar } from 'redux/navigation'
import { Icon, Image, Menu } from 'semantic-ui-react'

const mapStateToProps = (state) => {
  const { sidebarVisible, userName } = state.navigation
  return { sidebarVisible, userName }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleSidebar,
      hideSidebar,
    },
    dispatch
  )
}

class MenuAdmin extends React.Component {
  render() {
    const { sidebarVisible } = this.props
    const { toggleSidebar } = this.props

    return (
      <Menu
        className="menuAdmin scrollTop"
        color="black"
        fluid
        fixed="top"
        inverted
        secondary
        size="small"
        borderless>
        <Menu.Item
          onClick={() => {
            toggleSidebar()
          }}>
          <Icon
            name="bars"
            rotated={sidebarVisible ? 'clockwise' : null}
            size="large"
          />
        </Menu.Item>

        <Menu.Item fitted>
          <Navigation
            render="link"
            as="link"
            node="admin/dashboard"
            className="homeLink">
            <Image src={logo} size="tiny" />
          </Navigation>
        </Menu.Item>

        <Menu.Menu position="right">
          <Navigation node="admin/dashboard" as="menuitem" render="title" />
          <MenuItemAccount />
          <LogoutButton />
        </Menu.Menu>
      </Menu>
    )
  }
}

MenuAdmin = connect(mapStateToProps, mapDispatchToProps)(MenuAdmin)
export default MenuAdmin



// WEBPACK FOOTER //
// ./src/components/admin/Navigation/MenuAdmin.jsx